import { useState } from "react";
import { FetchStatusEnum } from "../enums/fetchStatusEnum";

/**
 * Хук для удобного управления вызовами API.
 * @param {() => Promise} apiCall Функция вызова API, возвращающая Promise
 * @param {any} [defaultValue=null] Начальное значение для данных
 * @returns {object} Параметры управления API вызова
 * */
export function useApiCall<ResultDataType>(
    apiCall: () => Promise<ResultDataType>,
    defaultValue: ResultDataType,
) {
    const [loadingStatus, setLoadingStatus] = useState(FetchStatusEnum.IDLE);
    const [data, setData] = useState<ResultDataType>(defaultValue);

    function resetApiCallStatus() {
        setLoadingStatus(FetchStatusEnum.IDLE);
    }

    function apiCaller(): Promise<ResultDataType | void> | null {
        if (loadingStatus === FetchStatusEnum.FETCHING) {
            return null;
        }

        setLoadingStatus(FetchStatusEnum.FETCHING);
        return apiCall()
            .then((data) => {
                setData(data);
                setLoadingStatus(FetchStatusEnum.SUCCESS);
                return data;
            })
            .catch(() => {
                setLoadingStatus(FetchStatusEnum.ERROR);
            });
    }

    return {
        error: loadingStatus === FetchStatusEnum.ERROR,
        success: loadingStatus === FetchStatusEnum.SUCCESS,
        loading: loadingStatus === FetchStatusEnum.FETCHING,
        default: loadingStatus === FetchStatusEnum.IDLE,
        data,
        setData,
        resetApiCallStatus,
        apiCaller,
    };
}
